import type { UserConfigurationState } from '@/types/userConfiguration';

export const premiumTypeOptions: { 
  value: UserConfigurationState['premiumShiftOffsetMode']; 
  label: string;
  description: string;
}[] = [
  { 
    value: 'multiplier_offset',
    label: 'Offset Overtime',
    description: 'Starts at the selected multiplier and progresses normally.'
  },
  { 
    value: 'fixed', 
    label: 'Fixed Premium',
    description: 'Adds a fixed dollar amount to each premium shift, regardless of duration or other factors.'
  },
  { 
    value: 'fixed_offset', 
    label: 'Fixed Rate Multiplier',
    description: 'Applies a consistent rate multiplier to all hours worked during the premium shift, maintaining the same elevated rate throughout.'
  },
];
